import { render, staticRenderFns } from "./message-abstract-video.vue?vue&type=template&id=1807cd34&scoped=true"
import script from "./message-abstract-video.vue?vue&type=script&lang=ts"
export * from "./message-abstract-video.vue?vue&type=script&lang=ts"
import style0 from "./message-abstract-video.vue?vue&type=style&index=0&id=1807cd34&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1807cd34",
  null
  
)

export default component.exports